export default "__VITE_ASSET__a23b5b90__"